import React from 'react';
import { Phone } from 'lucide-react';

const FloatingContactButton = ({ onClick }) => {
  return (
    <div className="fixed bottom-6 right-6 z-50 group">
      {/* Tooltip */}
      <div className="absolute bottom-14 right-0 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Contact Us
      </div>

      {/* Pulsing Button */}
      <button
        onClick={onClick}
        className="relative bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-700 transition-all"
        aria-label="Contact"
      >
        {/* Ping Animation */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75 animate-ping"></span>
        <span className="relative z-10 flex items-center justify-center">
          <Phone size={22} />
        </span>
      </button>
    </div>
  );
};

export default FloatingContactButton;
